import { render, staticRenderFns } from "./SampleDetails.vue?vue&type=template&id=b77018c4&scoped=true"
import script from "./SampleDetails.vue?vue&type=script&lang=js"
export * from "./SampleDetails.vue?vue&type=script&lang=js"
import style0 from "./SampleDetails.vue?vue&type=style&index=0&id=b77018c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77018c4",
  null
  
)

export default component.exports